<template>
  <section class="f-50">
    <div class="smart-group">
      <img class="bg" src="@/v2/auto/assets/image/50/bg.jpg" />
      <div class="smart-character" id="wisdom">
        <m-img
          width="300px"
          height="300px"
          src="@/v2/auto/assets/image/50/zhi.svg"
        />
      </div>
      <div class="promotional-group" ref="promotional">
        <div class="promotional_title f-center-title">全域 AI 座舱</div>
        <div class="promotional_des f-center-sub-title">
          <div>
            融合多家先进 AI
            大模型，打破智能座舱边界，以跨终端、多场景、全模态的情感感知和先进人机交互能力，
          </div>
          打造新时代的全域 AI 座舱
        </div>
        <VideoMask :videoSrc="videoSrc">
          <div class="promotional_btn">
            观看宣传片
            <VideoPlay />
          </div>
        </VideoMask>
      </div>
    </div>
  </section>
</template>

<script>
import VideoMask from '@/components/video-mask.vue'
import VideoPlay from '@/v2/auto/assets/image/0/video_play.vue'
import videoSrc from '@/v2/auto/assets/video/50/0.mp4'
export default {
  name: 'BeautyAlive',
  components: {
    VideoMask,
    VideoPlay,
  },
  data() {
    return {
      videoSrc,
      preload_: true,
    }
  },
  mounted() {},
  methods: {},
}
</script>

<style lang="less" scoped>
.f-50 {
  width: 100%;
  background-color: #000;
  position: relative;
  overflow: visible;

  .smart-group {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: top;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .bg {
      position: absolute;
      width: 100%;
      top: 0;
    }

    .smart-character {
      position: relative;
      z-index: 1;
      width: 100%;
      height: 100vh;
      display: flex;
      min-height: 960px;
      justify-content: center;
      align-items: center;
      margin-top: 10%;
      img {
        margin-left: 55px;
      }
    }
    .promotional-group {
      position: relative;
      z-index: 1;
      background: linear-gradient(to bottom, transparent, #000);
      width: 100%;
      height: 100vh;
      min-height: 960px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .promotional_title {
        color: #ffffff;
        font-weight: 700;
      }
      .promotional_des {
        text-align: center;
        color: #ffffff80;
        width: 860px;
        margin-top: 24px;
        line-height: 1.5;
      }
      .promotional_btn {
        cursor: pointer;
        font-size: 18px;
        color: #ffffff;
        width: 160px;
        margin-top: 40px;
        border-radius: 100px;
        background-color: #ffffff33;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 12px 0;
        gap: 10px;
      }
    }
  }
}
</style>
